import React, { useState } from 'react';

const UserModal = ({ user, onClose, onSave }) => {
    const [form, setForm] = useState({
        id: user.id,
        email: user.email,
        username: user.username,
        role: user.role,
        isVerified: user.isVerified,
        profile: user.profile || {}
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.startsWith('profile.')) {
            const key = name.split('.')[1];
            setForm(prev => ({ ...prev, profile: { ...prev.profile, [key]: value } }));
        } else {
            setForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = () => {
        onSave(form);
    };

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal admin-user-modal">
                <h3 className="admin-modal-title">Edit User</h3>
                <div className="admin-form-group">
                    <label className="admin-form-label">Email:</label>
                    <input 
                        name="email" 
                        value={form.email} 
                        onChange={handleChange}
                        className="admin-form-input"
                    />
                </div>
                <div className="admin-form-group">
                    <label className="admin-form-label">Username:</label>
                    <input 
                        name="username" 
                        value={form.username} 
                        onChange={handleChange}
                        className="admin-form-input"
                    />
                </div>
                <div className="admin-form-group">
                    <label className="admin-form-label">Role:</label>
                    <select 
                        name="role" 
                        value={form.role} 
                        onChange={handleChange}
                        className="admin-form-select"
                    >
                        <option value="user">user</option>
                        <option value="admin">admin</option>
                    </select>
                </div>
                <div className="admin-form-group">
                    <label className="admin-form-label">Verified:</label>
                    <select 
                        value={form.isVerified ? 'true' : 'false'} 
                        onChange={(e) => setForm(prev => ({ ...prev, isVerified: e.target.value === 'true' }))}
                        className="admin-form-select"
                    >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>
                <div className="admin-form-group">
                    <label className="admin-form-label">First Name:</label>
                    <input 
                        name="profile.firstName" 
                        value={form.profile.firstName || ''} 
                        onChange={handleChange}
                        className="admin-form-input"
                    />
                </div>
                <div className="admin-form-group">
                    <label className="admin-form-label">Last Name:</label>
                    <input 
                        name="profile.lastName" 
                        value={form.profile.lastName || ''} 
                        onChange={handleChange}
                        className="admin-form-input"
                    />
                </div>
                <div className="admin-modal-actions">
                    <button onClick={handleSubmit} className="admin-btn-save">Save</button>
                    <button onClick={onClose} className="admin-btn-cancel">Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default UserModal;